import {useSessionContext} from "../../reactContext/contextCustomHooks/useSessionContext"
import {useTeamContext} from "../../reactContext/contextCustomHooks/useTeamContext"
import {useTranslation} from "react-i18next"
import {useForm} from "react-hook-form"
import axios from "axios"
import {API_USERS} from "../../constants/apiUrls"
import {toast} from "react-toastify"
import isLicenceValidity from "../../tools/isLicenceValidity"

export default function AddTeamUsersForm({mutateTeam}) {
    const {t} = useTranslation()
    const {sessionContext} = useSessionContext()
    const {teamContext} = useTeamContext()
    const {register, reset, handleSubmit, formState: {errors}} = useForm()

    const addTeamUser = (data) => {
        if (isLicenceValidity(teamContext.licenceStartDate, teamContext.licenceEndDate)) {
            const bodyRequest = {
                email: data.email,
                id_team: sessionContext.idTeam,
                firstname: data.email,
                role: "user"
            }
            const headersRequest = {headers: {Authorization: `Bearer ${sessionContext.idToken}`}}
            axios.post(API_USERS, bodyRequest, headersRequest)
            .then(() => {
                reset({email: ""})
                mutateTeam()
                toast.success(t("Member added"))
            })
            .catch((err) => {
                switch (JSON.parse(err.request.response).message) {
                    case "Your Team has reached the number of members limit":
                        toast.error(t("You can't add a new creator to your license. Please liaise with the Neurowide sales department."))
                        break
                    case "User already in a team":
                        toast.error(t("This user is already part of a team!"))
                        break
                    default:
                        toast.error(t("An error has occurred"))
                }
            })
        } else {
            toast.error(t("Licence expired. Please contact Neurowide sales department."))
        }
    }

    return (
        <>
        <form className="add-team-users-form" onSubmit={handleSubmit(addTeamUser)}>
            <input type="email" id="email" name="email" placeholder="Email..." {...register("email", {required: true})}/>
            <button title={t("Add a member")}>
                {t("Add member")}
            </button>
        </form>
        </>
    )
}